/**
 *
 * AlignedImg
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const AlignedImg = ({
  src,
  align,
  alt,
  width,
  height,
}) => (
  <img
    src={src}
    className={`${styles.image} ${styles[align]}`}
    alt={alt}
    width={width}
    height={height}
  />
);

AlignedImg.propTypes = {
  align: PropTypes.oneOf([
    'left',
    'center',
    'right',
  ]),
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

AlignedImg.defaultProps = {
  align: 'center',
  width: null,
  height: null,
};

export default AlignedImg;



// WEBPACK FOOTER //
// ./src/components/AlignedImg/index.js